import { ActionDefinitionObject } from '../../types/ActionDefinition';
import { ActionResponseBody } from '../../types/api/definition';
import { EagGridState } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
import { getActions } from './getActions';

// Module-level cache — keyed on the identity of definition.actions array.
// When setDefinition() is called, the array reference changes → cache miss → recompute.
let cachedActionsArray: ActionResponseBody[] | null = null;
let cachedResult: ActionDefinitionObject | null = null;
const selectActionsDefinition = (state: EagGridState): ActionDefinitionObject | null => {
  const actions = state.definition?.actions ?? null;
  if (actions === null) {
    cachedActionsArray = null;
    cachedResult = null;
    return null;
  }
  if (actions === cachedActionsArray && cachedResult !== null) {
    return cachedResult; // stable reference — useSyncExternalStore skips re-render
  }
  cachedActionsArray = actions;
  cachedResult = getActions(actions);
  return cachedResult;
};

/**
 * Returns the ActionDefinitionObject derived from the grid definition in store.
 * Reference-stable: returns the same object until definition changes.
 * Consumers re-render only when the definition is replaced via setDefinition().
 */
export function useActionsDefinition(): ActionDefinitionObject | null {
  return useEagGridSelector(selectActionsDefinition);
}